/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_3_2 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-8.770303573587668, 5.466359010693033],
                        [-9.239969100931418, 5.466359010693033],
                        [-9.239969100931418, 4.965817530392297],
                        [-8.770303573587668, 4.965817530392297],
                        [-8.770303573587668, 5.466359010693033]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_3_2